import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {withStyles, createStyleSheet} from 'material-ui/styles'
import IconButton from 'material-ui/IconButton'
import PlayArrow from 'material-ui-icons/PlayArrow'
import Pause from 'material-ui-icons/Pause'
import Stop from 'material-ui-icons/Stop'
import br from './img/br.png'
import pt from './img/pt.png'

const styleSheet = createStyleSheet('Player', theme => ({
    container: {
        flex: 1,
        flexDirection: 'column',
        margin: theme.spacing.unit,
    },
    flag: {
        marginRight: theme.spacing.unit,
        marginBottom: 6,
    },
    hide: {
        color: 'white',
    }
}));

// must be to avoid, missing the onstart , onend event
let synthesise = null;

class Player extends Component {
    state = {
        playing: false,
        paused: false
    };

    waitVoices = new Promise((resolve) => {
        window.speechSynthesis.getVoices();
        speechSynthesis.onvoicechanged = () => resolve()
    });


    componentWillUnmount() {
        if(window.speechSynthesis !==undefined) {
            window.speechSynthesis.cancel()
        }
    }

    setVoice = (voice) => {

        let voices = window.speechSynthesis.getVoices();
        for (let i = 0; i < voices.length; i++) {
            if (voices[i].name === voice) {
                return voices[i];
            }
        }
        // default voice
        return voices[0]
    };

    play = (voice) => {

        if (!(window.speechSynthesis.speaking || window.speechSynthesis.paused)) {
            synthesise = new SpeechSynthesisUtterance(this.props.text);
            synthesise.voice = this.setVoice(voice);
            this.setState({playing: true});
            console.log('start', this.state)

            synthesise.onend = (event) => {

                this.setState({playing: false, paused: false});
                console.log('end', this.state)
            };
            synthesise.onpause = (event) => {

                this.setState({paused: true});
                console.log('pause', this.state)
            };
            synthesise.onresume = (event) => {

                this.setState({paused: false});
                console.log('resume', this.state)
            };

            window.speechSynthesis.speak(synthesise)
        }

    };

    onClick() {
        console.log('click', this.state)

        if (!this.state.playing && !this.state.paused) {

            if (this.props.lang === 'br') {
                this.play('Luciana')
            } else {
                this.play('Joana')
            }
            return
        }
        if (this.state.paused) {
            window.speechSynthesis.resume()
            return
        }
        if (this.state.playing) {
            window.speechSynthesis.pause()

        }
    }

    onCancel() {
        this.setState({paused: false, playing: false});
        window.speechSynthesis.cancel()
        console.log('cancel', this.state)
    }

    render() {

        if (window.speechSynthesis===undefined ) {
            return null
        }
        if (this.props.text === '') {
            return null
        }
        const classes = this.props.classes;
        const showPause = this.state.playing && (!this.state.paused);

        return (
            <div>
                <img className={classes.flag}
                     src={this.props.lang === 'br' ? br : pt}
                     alt={this.props.accent}
                     title={this.props.accent}
                />

                <IconButton onClick={this.onClick.bind(this)}>
                    {showPause ? <Pause/> : <PlayArrow/>}
                </IconButton>

                {this.state.playing ?
                    <IconButton onClick={this.onCancel.bind(this)}>
                        <Stop/>
                    </IconButton>
                    : null}
            </div>

        )
    }
}


Player.propTypes = {
    text: PropTypes.string.isRequired,
    lang: PropTypes.string.isRequired,
};

export default withStyles(styleSheet)(Player)


// WEBPACK FOOTER //
// ./src/player.js